import { z } from 'zod';

const objectKeySegmentSchema = z.string().trim().min(1).max(120).regex(/^[a-zA-Z0-9/_-]+$/, {
  error: 'Le dossier cible contient des caractères non autorisés.',
});

export const storageVisibilitySchema = z.enum(['private', 'public']);

export const createUploadUrlSchema = z.object({
  contentType: z.string().trim().min(1).max(255, {
    error: 'Le type MIME est requis.',
  }),
  filename: z.string().trim().min(1).max(255, {
    error: 'Le nom de fichier est requis.',
  }),
  folder: objectKeySegmentSchema.default('uploads'),
  visibility: storageVisibilitySchema.default('private'),
});

export const createDownloadUrlSchema = z.object({
  objectKey: z.string().trim().min(1).max(1024, {
    error: 'La clé objet est requise.',
  }),
});

export type CreateUploadUrlDTO = z.infer<typeof createUploadUrlSchema>;
export type CreateDownloadUrlDTO = z.infer<typeof createDownloadUrlSchema>;
